module.exports = __webpack_public_path__ + "img/seo.5a09d366.svg";